module.exports = __webpack_public_path__ + "media/images/header-15a71520.jpg";